import {BelongsTo, Fillable, Path, PrimaryKey, UploadRestModel} from 'ng-rest-model';
import {HasId, Timestamped} from '../../shared/interfaces';
import {Series} from './series';

@Path('lectures')
@BelongsTo('series', Series)
export class Lecture extends UploadRestModel implements HasId, Timestamped {

    @PrimaryKey()
    id: number;

    @Fillable()
    series_id: number;

    @Fillable()
    number: number;

    @Fillable()
    preacher: string;

    @Fillable()
    file: string;

    created_at: string;
    updated_at: string;

    // BelongsTo
    series: Series;
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/classes/lecture.ts